const steps = [
    {
        'id': 0,
        'label': 'Proveedor'
    },
    {
        'id': 1,
        'label': 'Consultorios'
    },
    {
        'id': 2,
        'label': 'Especialidades'
    },
    {
        'id': 3,
        'label': 'Fecha de publicación'
    },
    {
        'id': 4,
        'label': 'Verificación'
    }
];

export { steps };